// @flow

import * as React from "react";
import type { CSSProperties } from "styled-components";

import Icon from "src/icons";

import { Button as StyledButton, AnimatedButton } from "./styles";

type Props = {
  isLoading?: boolean,
  variant: string,
  children?: React.Node,
  disabled?: boolean,
  color?: string,
  handleClick?: Function,
  bgColor?: string,
} & CSSProperties;

const Button = ({
  isLoading = false,
  variant,
  children = null,
  disabled = false,
  handleClick = () => {},
  bgColor,
  ...restProps
}: Props) => {
  if (isLoading) {
    return (
      <AnimatedButton
        autoFocus={false}
        variant={variant}
        disabled
        bgColor={bgColor}
        {...restProps}
      >
        <Icon type="spinner" />
      </AnimatedButton>
    );
  }

  return (
    <StyledButton
      autoFocus={false}
      variant={variant}
      disabled={disabled}
      onClick={handleClick}
      bgColor={bgColor}
      {...restProps}
    >
      {children || null}
    </StyledButton>
  );
};

export default Button;
